import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-tag',
  templateUrl: './adc-tag.component.html',
  styleUrls: ['./adc-tag.component.scss'],
  standalone: false
})
export class AdcTagComponent {
  @Input('type') type: string = 'basic';
  @Input('data') data: any;
}
